// Sigorta Yönetimi (/employee-insurance) ve sigorta formu. Excel dosyası Türkçe kalır.
const insurance = {
  page: {
    title: 'Sigorta Yönetimi',
    subtitle: 'Çalışanların ferdi kaza, tamamlayıcı sağlık ve malpraktis sigortaları ile BES durumu.',
  },
  actions: {
    add: 'Sigorta Ekle',
    excel: 'Tabloyu İndir',
    excelHint: 'Tüm sigorta kayıtlarını Excel olarak indir',
  },
  stats: {
    total: 'Toplam Sigorta',
    totalShort: 'Toplam',
    withBES: 'BES’li Çalışan',
    withBESShort: 'BES’li',
    expiring: 'Bitişi Yaklaşan',
    expiringShort: 'Yaklaşan',
    totalCost: 'Toplam Maliyet',
    totalCostShort: 'Maliyet',
    share: 'Tüm kayıtların %{{percent}}’i',
  },
  toolbar: {
    search: 'Çalışan adı ile ara…',
    searchShort: 'Çalışan ara…',
    expiring: 'Bitişi yaklaşanlar',
    expiringHint: 'Herhangi bir sigortasının bitiş tarihi 1 ay içinde olanlar',
    bes: 'BES’li',
    besHint: 'Yalnızca BES’i olan çalışanlar',
  },
  types: {
    accidentInsurance: 'Ferdi Kaza Sigortası',
    complementaryHealth: 'Tamamlayıcı Sağlık Sigortası',
    malpractice: 'Malpraktis Sigortası',
  },
  typesShort: {
    accidentInsurance: 'Ferdi Kaza',
    complementaryHealth: 'Tamamlayıcı Sağlık',
    malpractice: 'Malpraktis',
  },
  columns: {
    employeeName: 'Çalışan Adı',
    hasBES: 'BES Durumu',
    accidentStart: 'Ferdi Kaza Başlangıç',
    accidentEnd: 'Ferdi Kaza Bitiş',
    healthStart: 'Tamamlayıcı Sağlık Başlangıç',
    healthEnd: 'Tamamlayıcı Sağlık Bitiş',
    malpracticeStart: 'Malpraktis Başlangıç',
    malpracticeEnd: 'Malpraktis Bitiş',
    cost: 'Maliyet',
  },
  bes: {
    yes: 'Var',
    no: 'Yok',
    badge: 'BES: {{value}}',
  },
  state: {
    expired: 'Süresi doldu',
    today: 'Bugün bitiyor',
    soon: '{{days}} gün kaldı',
    ok: 'Geçerli',
  },
  table: {
    listLabel: 'Sigorta listesi',
    empty: 'Sigorta kaydı bulunamadı',
    rangeOf: '/ {{total}} sigorta',
    ofTotal: 'toplam {{total}} kayıt içinden',
    jump: 'Sayfaya git',
  },
  panel: {
    label: 'Seçili sigorta',
    heading: 'Sigorta',
    edit: 'Düzenle',
    delete: 'Sil',
    policies: 'Sigortalar',
    noPeriod: 'Tarih girilmemiş',
    costPerPerson: 'Kişi bazlı maliyet',
    total: 'Toplam maliyet',
  },
  form: {
    newTitle: 'Sigorta Ekle',
    editTitle: 'Sigortayı Düzenle',
    subtitle: 'BES durumu, sigorta dönemleri ve kişi bazlı maliyetler',
    employee: 'Çalışan',
    employeePlaceholder: 'Çalışan seçin',
    noEmployees: 'Sigortası olmayan aktif çalışan bulunamadı',
    employeeHint: 'Yalnızca sigorta kaydı olmayan aktif çalışanlar listelenir.',
    bes: 'BES',
    yes: 'Evet',
    no: 'Hayır',
    start: 'Başlangıç tarihi',
    end: 'Bitiş tarihi',
    cost: 'Kişi bazlı maliyet (₺)',
    total: 'Toplam maliyet (₺)',
    totalAuto: 'Kişi bazlı maliyetlerden otomatik hesaplanır.',
    totalManual: 'Kişi bazlı maliyet girilmediği için toplamı elle girebilirsiniz.',
    cancel: 'İptal',
    save: 'Kaydet',
    update: 'Güncelle',
    saving: 'Kaydediliyor…',
    errors: {
      employee: 'Lütfen bir çalışan seçiniz',
      cost: 'Maliyet sayısal bir değer olmalıdır',
    },
  },
  delete: {
    title: 'Sigortayı Sil',
    message: '{{name}} için sigorta kaydını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    confirm: 'Evet, sil',
    cancel: 'Vazgeç',
  },
  toast: {
    loadError: 'Sigorta bilgileri alınırken bir hata oluştu',
    employeesError: 'Çalışan bilgileri alınırken bir hata oluştu',
    expiring_one: '{{count}} sigortanın bitiş tarihi 1 ay içinde!',
    expiring_other: '{{count}} sigortanın bitiş tarihi 1 ay içinde!',
    deleted: 'Sigorta başarıyla silindi',
    deleteError: 'Sigorta silinirken bir hata oluştu',
    excelDone: 'Excel dosyası başarıyla indirildi',
    formErrors: 'Lütfen form hatalarını düzeltin',
    added: 'Sigorta başarıyla eklendi',
    updated: 'Sigorta başarıyla güncellendi',
    saveError: 'Sigorta kaydedilirken bir hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default insurance;
